import { createFileRoute, redirect } from "@tanstack/react-router";

/** Clients moved to /trainees. Old links (bookmarks, sent emails) land on the same page there. */
export const Route = createFileRoute("/(private)/clients/$")({
  beforeLoad: ({ params, location }) => {
    throw redirect({ href: `/trainees/${params._splat ?? ""}${location.searchStr}`, replace: true });
  },
});
